import { Card, Grid, Group, Stack, Text, Title } from "@mantine/core";
import { useAuth } from "@/lib/auth";

export default function HomePage() {
  const { user } = useAuth();
  return (
    <Stack gap="lg">
      <div>
        <Title order={1}>Главная</Title>
        <Text c="dimmed">Здравствуйте, {user?.full_name}!</Text>
      </div>
      <Grid>
        <Grid.Col span={{ base: 12, md: 4 }}>
          <Card withBorder padding="lg" radius="md">
            <Group justify="space-between">
              <Text fw={500}>Ваша роль</Text>
            </Group>
            <Text size="xl" fw={700} mt="md">{user?.role_code}</Text>
            <Text size="sm" c="dimmed" mt="xs">Доступно прав: {user?.permissions.length ?? 0}</Text>
          </Card>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 8 }}>
          <Card withBorder padding="lg" radius="md">
            <Title order={3} mb="sm">Быстрые ссылки</Title>
            <Text size="sm" c="dimmed">
              Используйте навигацию слева для перехода в разделы.
              Дашборд с метриками появится в следующих фазах.
            </Text>
          </Card>
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
